module.exports = __webpack_public_path__ + "img/collection-engagementRingsDiamond.8b8dcff.webp";